// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1hz16","ranges":"BmiRanges_ranges__2c_J4"};